import { privateApi, privateApiWithBlob} from "../api/axios";
import { ICreateCreditNote, ICreateInvoice } from "../interfaces/invoices";

// PROFORMA
export const getProformas = async () => {
    try {
        const response = await privateApi.get("api/invoices/proformas");
        return response;
    } catch (error) {
        throw error;
    }
}

export const getProforma = async (id: number) => {
    try {
        const response = await privateApi.get(`api/invoices/proforma/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateProforma = async (id: number, data: ICreateInvoice) => {
    try{
        const response = await privateApi.patch(`api/invoices/proforma/${id}`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteProforma = async (id: number) => {
    try {
        const response = await privateApi.delete(`api/invoices/proforma/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getProformaPdf = async (id: number) => {
    try {
        const response = await privateApiWithBlob.get(`api/invoices/proforma/${id}/document`, { responseType: 'blob' });
        return response;
    } catch (error) {
        throw error;
    }
}

export const validateProforma = async (data: number[]) => {
    try {
        const response = await privateApi.post(`api/invoices/proformas/validate`, {idsProforma : data});
        return response;
    } catch (error) {
        throw error;
    }
}

// FACTURES
export const getInvoices = async () => {
    try {
        const response = await privateApi.get("api/invoices");
        return response;
    }
    catch (error) {
        throw error;
    }
}

export const getInvoice = async (id: number) => {
    try {
        const response = await privateApi.get(`api/invoices/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}


export const getInvoicePdf = async (id: number) => {
    try {
        const response = await privateApiWithBlob.get(`api/invoices/${id}/document`, { responseType: 'blob' });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getInvoicesCSV = async () => {
    try {
        const response = await privateApiWithBlob.get(`api/invoices/export/csv`, { responseType: 'blob' });
        return response;
    } catch (error) {
        throw error;
    }
}

// DOCUMENTS
export const getInvoicesDocuments = async (idsDoc: number[]) => {
    try {
        const response = await privateApiWithBlob.get(`api/invoices/documents?ids=${idsDoc}`, {
            responseType: 'blob'
        });
        return response;
    } catch (error) {
        throw error; 
    }
};

// AVOIR
export const createCreditNote = async (idInvoice: number, data: ICreateCreditNote) => {
    try {
        const response = await privateApi.post(`api/invoices/${idInvoice}/creditnote`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

//PRODUCTION
export const getProductionInvoices = async (startDate: string, endDate: string, idDepartment: number | null) => {
    try {
        const response = await privateApi.get(`api/invoices/report?startDate=${startDate}&endDate=${endDate}&idDepartment=${idDepartment}`);
        return response;
    } catch (error) {
        throw error;
    }
}